







































































































import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import InputField from '@/ts/InputField';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';

@Component
export default class ResetPassword extends Mixins(InputFieldMethods, DeviceMethods) {
    constructor() {
        super();
    }

    get email(): string {
        return this.$store.getters['User/getResetEmail'];
    }

    set email(value: string) {
        this.$store.commit(Mutations.UPDATE_PASSWORD_RESET_EMAIL, value);
        return;
    }

    get resetPasswordSent(): boolean {
        return this.$store.state.User.resetPasswordEmailSent;
    }

    public goBack() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Documents,
            viewMode: ViewModes.Documents.All,
        });
        this.$router.back();
    }

    public dismissDialog() {
        this.$store.commit(Mutations.RESET_RESET_PASSWORD);
        this.$router.push('login');
    }

    public resetPassword() {
        this.$store.dispatch(Actions.RESET_PASSWORD);
    }

    public created() {
        this.inputs['hococo-form-login-email'] = new InputField('hococo-form-login-email');
    }
}
